import Button from './Button'
import PropTypes from 'prop-types'
import React from 'react'

const CloseButton = ({ className, ...props }) => (
  <Button {...props} kind="clear" className="fv-button-close">
    &times;
  </Button>
)

CloseButton.propTypes = {
  children: PropTypes.node
}

export default CloseButton



// WEBPACK FOOTER //
// ../src/components/fv-ui/CloseButton.js